export default "__VITE_ASSET__6hfreZRv__"